<div class="p-5 pt-0 flex-column height-100 text gap-3 shadow">
    <classification-node-selector-v2
        class="reset-flex-mins"
        [enableAllBuildingsNodeSelection]="true"
        [enableBuildingSelection]="true"
        (selectedClassificationNodeLight)="pickedClassificationNodeLight = $event"
        (selectedFavoriteClassificationNodeId)="changeClassificationFromSelectedFavoriteClassification($event)"
    />

    <div class="flex-row justify-end gap-1">
        <button
            ui-button
            type="button"
            color="primary"
            buttonStyle="outline"
            [disabled]="isSavePerimeterDisabled()"
            (click)="savePerimeter()"
        >
            {{ 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.ADD_NEW_FAVORITE_PERIMETER' | translate }}
        </button>

        <button ui-button type="button" color="primary" [disabled]="!pickedClassificationNodeLight" (click)="validate()">
            {{ 'BUTTONS.VALIDATE' | translate }}
        </button>
    </div>
</div>
